var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.752V32.5H14C14 28.0817 17.5817 24.5 22 24.5C22.6906 24.5 23.3608 24.5875 24 24.752ZM22 23.5C18.685 23.5 16 20.815 16 17.5C16 14.185 18.685 11.5 22 11.5C25.315 11.5 28 14.185 28 17.5C28 20.815 25.315 23.5 22 23.5ZM28 27.5V24.5H30V27.5H33V29.5H30V32.5H28V29.5H25V27.5H28Z",
    fill: "#3f5065"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteMemberIcon);
export default __webpack_public_path__ + "static/media/inviteMemberIcon.f10ee836.svg";
export { ForwardRef as ReactComponent };